import { MetapageVersionsAll, MetaframeVersionsAll } from "./v0_4";
export const METAFRAME_JSON_FILE = "metaframe.json";
export const METAPAGE_KEY_DEFINITION = "metapage/definition";
export const METAPAGE_KEY_STATE = "metapage/state";
export const VERSION_METAPAGE = MetapageVersionsAll[MetapageVersionsAll.length - 1];
export const VERSION_METAFRAME = MetaframeVersionsAll[MetaframeVersionsAll.length - 1];
//# sourceMappingURL=Constants.js.map